<template>
    <mdb-container fluid>    
        <mdb-row class="justify-content-md-center">
           <mdb-col lg="10" class="space-down">
                <carousel-featured></carousel-featured>
            </mdb-col>
            <mdb-col lg="10" class="space-down">
                <main-menu></main-menu>
            </mdb-col>
            <mdb-col lg="10" class="space-down">
                <card-group-featured></card-group-featured>
            </mdb-col>
           <!-- <mdb-col lg="10" class="space-down">
                <card-slide-interactive-block></card-slide-interactive-block>
            </mdb-col>-->

            <mdb-col lg="10" class="space-down">
                <mdb-card-group deck>
                    <new-details></new-details>
                    <twitter-feed></twitter-feed>
                    <tag-clouds></tag-clouds>
                    
                    
                </mdb-card-group>    
            </mdb-col>
            <mdb-col lg="10" class="space-down">
               
            </mdb-col>

            
        </mdb-row>
        
  </mdb-container>
     

</template>

<script>
import CarouselFeatured from '@/components/ThemeMDB/home/partials/CarouselFeatured';
import CardGroupFeatured from '@/components/ThemeMDB/home/partials/CardGroupFeatured';
import CardSlideInteractiveBlock from '@/components/ThemeMDB/home/partials/CardSlideInteractiveBlock';
import MainMenu from '@/components/ThemeMDB/menu/MainMenu';
import TagClouds from '@/components/ThemeMDB/home/partials/TagClouds';
import TwitterFeed from '@/components/ThemeMDB/home/partials/TwitterFeed';
import NewDetails from '@/components/ThemeMDB/home/partials/NewDetails';

import { mdbRow, mdbContainer, mdbCol,mdbCardGroup } from 'mdbvue';
export default {
    name: 'Body',
    components:{
        CarouselFeatured,
        CardGroupFeatured,
        TagClouds,
        mdbContainer,
        mdbRow,
        mdbCol,
        MainMenu,
        CardSlideInteractiveBlock,
        TwitterFeed,
        NewDetails,
        mdbCardGroup
    }
 
};
</script>
<style scoped>
    .space-down{
        padding-bottom: 18px;
        
    }
</style>

